export default __webpack_public_path__ + "static/media/status-unknown-icon.15edbf61.svg";